import React from 'react';

import styles from './Input.module.scss'

const Radio = ({name, id, value = '', label, onChange = () => {}, required = false}) => {
    return (
        <div className={styles.radio}>
            <input id={id} type="radio" name={name} value={id} checked={id === value} onChange={onChange} required={required} />
            <label htmlFor={id}>{label}</label>
        </div>
    )
}

Radio.Group = ({label, children}) => {
    return (
        <div className={styles.radioGroupContainer}>
            <label>{label}</label>
            <div className={styles.radioGroup}>
                {children}
            </div>
        </div>
    )
}

export default Radio;